import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FaArrowUp } from "react-icons/fa";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 300);
    };

    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll to top"
      title="Back to top"
      className="fixed bottom-24 right-5 z-[998] inline-flex h-12 w-12 items-center justify-center rounded-full border-2 border-white bg-[#334780] text-white shadow-xl transition hover:scale-105 hover:bg-[#24335f] focus:outline-none focus:ring-2 focus:ring-[#334780] focus:ring-offset-2"
    >
      <FaArrowUp size={16} />
    </button>
  );
}
